<style lang="stylus" scoped>
@import './cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}
</style>

<template>
  <div class="home-main">
    <div class="map-search">
      <div class="map-title">
        <el-row>
          <CardHeader/>
        </el-row>
      </div>
      <map-data-table
        :areaList="areaList"
        v-if="areaList&&areaList.length>0"
        :changeCity="changeCity"
      ></map-data-table>
    </div>
    <div class="map-data">
      <div class="map-area">
        <home-map :city-data="cardData" :dataType="dataType" :title="title"></home-map>
      </div>
      <map-card :cardItem="cardData"></map-card>
    </div>
  </div>
</template>
<script>
import homeMap from './components/map.vue'
import mapDataTable from './components/mapDataTable.1.vue'
import mapCard from './components/mapCard.vue'
import CardHeader from './components/cardHeader.vue'

import http from '@/api/cardData'
import Cookies from 'js-cookie'
import allData from './index.js'
export default {
  name: 'home',
  components: {
    homeMap,
    mapDataTable,
    mapCard,
    CardHeader
  },
  data() {
    return {
      cityData: [],
      areaList: [], //省列表
      dataType: '6', //点击省份详情列表
      title: 0, //地图标题
      tab: 0,
      progressNum: 0, //进度条进度
      mark: false, //是否显示遮罩层
      all: allData,
      cardData: allData.total
    }
  },
  watch: {
  },
  computed: {
    allTab: function() {
      return this.$store.state.app.tab
    },
    titleArr: function() {
      return this.$store.state.app.titleArr
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      let that = this
      that.areaList = allData.list
    },
    changeCity(index) {
      if (index == -1) {
        this.cardData = allData.total
      } else {
        this.cardData = allData.list[index]
      }
    }
  }
}
</script>
